import { z } from 'zod';
import { numberParameter, positiveIndex } from './shared.js';

export default {
  label: 'Higher-order Wave Aberrations', group: 'performance',
  description: 'Fourth-order image and pupil aberration coefficients, and sixth-order intrinsic, extrinsic and total coefficients.',
  settingsSchema: z.strictObject({
    output_flag: z.number().int().min(0).max(5).default(2).describe('Native WaveAberrationTable flag: 0 all groups; 1 fourth and sixth image; 2 sixth; 3 intrinsic; 4 extrinsic; 5 total (Macro-PLUS pp325–326).'),
    zoom: positiveIndex.default(1).describe('Native zoom position, 1-based. WaveAberrationTable defaults to position 1 and rejects position 0.'),
  }),
  parameters: [
    { key: 'output_flag', label: 'Coefficient groups (0–5)', kind: 'number', integer: true, unit: '', nullable: false, placeholder: '0–5' },
    numberParameter('zoom', 'Zoom position', { integer: true, hidden: true }),
  ],
  coverage: 'Surface contributions and system totals, in waves at the reference wavelength. CODE V\'s warnings for non-symmetric lenses are shown; failed calculations are not.',
} as const;
